export const SCHOOL_LUNCH_BOX_ORDER_DELIVERY_TIMES = [
    "REGULAR_DELIVERY",
    "DELIVERY_CUTOFF_07_00",
    "DELIVERY_CUTOFF_07_30",
    "DELIVERY_CUTOFF_08_00",
    "DELIVERY_CUTOFF_08_30",
    "DELIVERY_CUTOFF_09_00",
    "DELIVERY_CUTOFF_09_30",
    "DELIVERY_CUTOFF_10_00",
    "DELIVERY_CUTOFF_10_30",
    "DELIVERY_CUTOFF_11_00",
];
//# sourceMappingURL=LunchBoxOrder.js.map